import script from "./rent_process_view_component.vue?vue&type=script&setup=true&lang=js"
export * from "./rent_process_view_component.vue?vue&type=script&setup=true&lang=js"

import "./rent_process_view_component.vue?vue&type=style&index=0&id=f4fb0674&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4fb0674"]])

export default __exports__